<template>
  <div>
    <BaseButton
      variant="blue-transparent"
      :disabled="isLoading"
      @click="onExport"
    >
      <BaseLoader v-if="isLoading" size="xs" class="mr-1" />
      Экспорт ЛМСЗ
    </BaseButton>
    <a ref="link" :href="link" target="_blank" class="hidden"></a>
  </div>
</template>

<script>
  import Client from '@/classes/Api/Client';
  import BaseButton from '@/components/global/base-button';
  import BaseLoader from '@/components/global/base-loader';

  export default {
    name: 'LMSPExportBtn',

    components: {
      BaseButton,
      BaseLoader,
    },

    data() {
      return {
        link: null,
        maxTries: 10,
        interval: 2000,
        isLoading: false,
      };
    },

    methods: {
      onExport() {
        if (!(!this.isLoading && (this.isLoading = true))) {
          return;
        }

        Client.startExport()
          .then((response) => {
            let data = response.data;
            this.startCheckExport(data.id);
          })
          .catch(() => {
            this.isLoading = false;
          });
      },

      startCheckExport(id) {
        let counter = 0;
        let timerId = setInterval(() => {
          Client.checkExport(id)
            .then((response) => {
              counter++;
              if (counter > this.maxTries) {
                clearInterval(timerId);
                this.isLoading = false;

                this.$store.commit('Notification/showAlert', {
                  title: 'Ошибка!',
                  message:
                    'Произошла ошибка, пожалуйста попробуйте повторить выгрузку.',
                });
              }

              let data = response.data;
              if (data.result === true) {
                clearInterval(timerId);
                this.isLoading = false;
                this.download(id);
              }
            })
            .catch(() => {
              clearInterval(timerId);
              this.isLoading = false;
            });
        }, this.interval);
      },

      download(id) {
        this.link = Client.getDownloadExportUrl(id);

        this.$nextTick(() => {
          this.$refs['link'].click();
        });
      },
    },
  };
</script>
